/**
 * Normalizes a vue-router query value to a single string. A query value is an
 * array when the same query key appears more than once in the URL; this just
 * takes the first occurrence, which is the only case these callers ever expect.
 */
export function asQueryString(value) {
    if (Array.isArray(value)) {
        return value.length > 0 ? value[0] : null;
    }
    return value != null ? value : null;
}
export function removeURLParameter(url, param) {
    var urlParts = url.split('?');
    if (urlParts.length >= 2) {
        var prefix = encodeURIComponent(param) + '=';
        var pars = urlParts[1].split(/[&;]/g);
        for (var i = pars.length; i-- > 0;) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }
        return urlParts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
}
